<!-- /* [MP-MATCH-SEND-TAB] 나의 매칭현황 - 보낸 신청서 */ -->

<template>
  <section>
    <div class="inner row3_1 flex mobileFlexCol">
      <article class="wd100">
        <div class="advisoryManagement">
          <h1 class="mainTitle">직접 매칭 관리</h1>

          <article class="aRow2">
            <h3 class="alignL statusMatchingTitle">
              매칭 현황
            </h3>
            <section class="flex statusMatchingRow">
              <div
                class="statusMatchingItem"
                v-for="(item, index) in statusMatchingItems"
                :key="index"
              >
                <div class="boxText">
                  <h4 class="boxTextTitle">{{ item.title }}</h4>
                  <h2 class="boxTextNumber" :style="{ color: item.textColor }">
                    {{ item.number }}
                  </h2>
                </div>

                <figure class="image">
                  <img :src="item.icon" :alt="item.title" />
                </figure>

                <div
                  class="lineBottom"
                  :style="{ backgroundColor: item.lineColor }"
                ></div>
              </div>
            </section>
          </article>

          <article class="aRow2 nap">
            <h3 class="alignL statusMatchingTitle">
              NAP 매칭 목록
            </h3>

            <div class="selectOption">
              <SelectOption :options="options" />
            </div>

            <div class="napaLists">
              <div v-for="(item, i) in items" :key="i">
                <ItemSentAdmin :data="item" @onReload="napList" />
              </div>
            </div>
          </article>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import SelectOption from "@/components/formControl/SelectOption.vue";
import ItemSentAdmin from "@/components/matching/ItemSentAdmin.vue";
export default {
  name: "NapManagement",
  components: { SelectOption, ItemSentAdmin },
  data() {
    return {
      options: [{ value: null, text: "전체선택" }],
      statusMatchingItems: [
        {
          id: 1,
          title: "총 신청 수",
          number: "1423 건",
          icon: "/images/manager/matching/docs.svg",
          lineColor: "#8D98C8",
          textColor: "#26336A",
        },
        {
          id: 1,
          title: "매칭 대기",
          number: "123 건",
          icon: "/images/manager/matching/community.svg",
          lineColor: "#B1DF8D",
          textColor: "#3F7416",
        },
        {
          id: 1,
          title: "자문 완료",
          number: "1423 건",
          icon: "/images/manager/matching/user.svg",
          textColor: "#2B939A",
          lineColor: "#70CED4",
        },
      ],
      items: [],
      params: {
        requesterIdx: this.$store.state.auth.user.idx,
      },
    };
  },
  mounted() {
    this.napList();
  },
  methods: {
    ...mapActions("matching", ["napGetByRequester"]),
    handleChangeTab(tabActive) {
      const that = this;
      this.isReceived = tabActive;
      if (tabActive) {
        that.deirectList();
      } else {
        that.napList();
      }
    },
    napList() {
      const that = this;
      this.napGetByRequester(that.params).then((res) => {
        that.items = res;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.advisoryManagement {
  .advisoryManagementTitle {
    color: #9e1915;
    text-align: center;
  }

  .statusMatchingTitle {
    color: #26336a;
  }

  .statusMatchingRow {
    padding-top: 40px;
    gap: 0 6rem;
    justify-content: center;
  }

  .statusMatchingItem {
    width: 240px !important;
    height: 302px !important;
    background: #ffffff !important;
    border: 1px solid #ededed;
    border-radius: 10px;
    position: relative;
    overflow: hidden;

    .boxText {
      text-align: center;
      padding-top: 37px;

      .boxTextTitle {
        color: #6c6c6c;
      }

      .boxTextNumber {
        color: #26336a;
      }
    }

    .image {
      padding-top: 30px;
      height: 90px;
    }

    .lineBottom {
      position: absolute;
      height: 16px;
      width: 100%;
      background-color: #8d98c8;
      bottom: 0;
    }
  }

  .mainTitle {
    &::after {
      display: none !important;
    }
  }
}

.nap {
  .selectOption {
    display: flex;
    justify-content: flex-end;
    border-bottom: 1px solid #d6d6d6;
    margin-bottom: 24px;
    padding-bottom: 12px;
  }
}
</style>
